const WelcomeCard = ({
  title,
  description,
  current,
  target,
  firstButtonText,
  secondButtonText,
  firstButtonClass = "bg-custom-blue py-3 px-5 rounded-lg w-full sm:w-auto transition-all duration-300 ease-in-out hover:brightness-110 hover:shadow-lg",
  secondButtonClass = "bg-custom-pink py-3 px-5 rounded-lg w-full sm:w-auto transition-all duration-300 ease-in-out hover:brightness-110 hover:shadow-lg",
  firstButtonClick,
  secondButtonClick,
}) => {
  return (
    <div className="rounded-xl bg-custom-gradient py-8 px-6 md:px-10 text-white">
      <p className="font-bold text-2xl md:text-4xl">{title}</p>
      {description && (
        <p className="font-light text-sm md:text-base max-w-[750px] my-4">
          {description}
        </p>
      )}
      {(current || target || firstButtonText || secondButtonText) && (
        <div className="my-4 grid grid-cols-1 gap-6 xl:flex xl:justify-between xl:gap-12">
          <div className="font-semibold text-base">
            {current && (
              <p>
                Your Current Occupation:
                <span className="font-normal">
                  {` `}
                  {current}
                </span>
              </p>
            )}
            {target && (
              <p>
                Your Selected Target AI Resilient Career:
                <span className="font-normal">
                  {` `}
                  {target}
                </span>
              </p>
            )}
          </div>
          <div className="flex flex-col gap-4 sm:flex-row sm:gap-6 xl:gap-12 items-center font-medium text-xs">
            {firstButtonText && (
              <button
                onClick={firstButtonClick}
                className={`${firstButtonClass}`}
              >
                {firstButtonText}
              </button>
            )}
            {secondButtonText && (
              <button
                onClick={secondButtonClick}
                className={`${secondButtonClass}`}
              >
                {secondButtonText}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WelcomeCard;
